import { disablePageScroll, enableScroll } from '../utils/scroll';

export default function () {
  const wrapper = document.querySelector('.wrapper');
  const videoBlocks = wrapper.querySelectorAll('.video');

  if (!videoBlocks.length) return;
  const popup = document.createElement('div');

  const closePopup = (event) => {
    event.preventDefault();
    popup.classList.remove('shown');
    popup.querySelector('.video-popup__frame').innerHTML = '';
    setTimeout(function () {
      enableScroll();
    }, 500);
  };

  for (const block of videoBlocks) {
    const btn = block.querySelector('.play-btn');
    const id = block.getAttribute('data-id');
    const host = block.getAttribute('data-host');

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      disablePageScroll(true);
      if (host === 'youtube') {
          wrapper.querySelector('.video-popup__frame').innerHTML = '<iframe src="https://www.youtube.com/embed/' + id + '?showinfo=0&controls=0&autoplay=1" title="YouTube video player" frameborder="0" allowfullscreen style="display:block; height:100%; width: 100%; position: absolute;" ></iframe>';
      } else {
        wrapper.querySelector('.video-popup__frame').innerHTML = '<iframe src="https://player.vimeo.com/video/' + id + '?autoplay=1" title="Vimeo video player" frameBorder="0"\n' +
            '        allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style="display:block; height:100%; width: 100%; position: absolute;" ></iframe>';
      }
      wrapper.querySelector('.video-popup').classList.add('shown');
    });
  }

  popup.classList.add('video-popup');
  popup.innerHTML = '<div class="video-popup__overlay"></div><div class="video-popup__frame"></div><a class="video-popup__close" href="#"></a>';
  wrapper.appendChild(popup);

  popup.querySelectorAll('.video-popup__close, .video-popup__overlay').forEach(function (element) {
    element.addEventListener('click', closePopup);
  });
}
